
<template>
  <div class="record_box"
       style="height:100%;">

    <div ref="mescroll"
         class="mescroll noticeBox">
      <div>
        <div class="record_item"
             id="noticeList">
          <div class="look_limit"
               v-for="(item,idx) in list"
               :key="idx"
               :class="{'fr':idx%2}"
               @click="toPage(item)">
            <span class="isHot"
                  v-if="item.status"></span>
            <img class="logo"
                 :src="item.imgSmall" />
            <p class="name">{{item.customizeName}}</p>
            <p><span class="coins"></span> <span class="limit ">{{item.price}}金币</span></p>
            <p class="moreMoney">{{item.receiveCount}}人已兑换</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'
export default {
  components: {
    MeScroll
  },
  data () {
    return {
      customerId: '',
      list: [],
      money: '',
      isEmpty: false,
      balanceList: [],
      page: 1,
      pageSize: 10,
      mescroll: null, //mescroll实例对象
    }
  },
  mounted () {
    this.util.title('金币商城');
    let _this = this;
    // this.getBalanceList();
    _this.mescroll = new MeScroll(_this.$refs.mescroll, { //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      up: {
        auto: true,
        callback: _this.getList, //上拉回调
        page: {
          size: 10
        },
        clearEmptyId: 'noticeList',
        offset: 10,
        noMoreSize: 3,
        htmlNodata: '<p class="upwarp-nodata">-- End --</p>'
      },
      down: {
        auto: false,//自动加载
        isBounce: false,
        callback: _this.downCallback
      }
    });
  },
  methods: {
    /**
            * 下拉刷新
            */
    downCallback () {
      this.list = []//重置数组
      //下拉刷新的回调
      this.mescroll.resetUpScroll();
    },
    getList (page) {
      let _this = this;
      let param = {
        pageNum: page.num,
        pageSize: this.pageSize,
      }
      this.$get('/app/valueAdded/goldProducts', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            let productList = e.data.data;
            _this.mescroll.endBySize(productList.length, e.data.total);
            _this.list = _this.list.concat(productList);
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    toPage (item) {
      // 进入监测页面
      this.$router.push({
        path: '/vipActive/couponDetailList',
        query: {
          id: item.id
        }
      });
    },

  }

}
</script>
<style scoped>
.record_box {
  font-family: PingFangSC-Regular;
  background: #f7f7f7;
  padding: 0.1rem 0.15rem;
}
.record_item {
  /* display: flex;
  flex: 1;
  justify-content: space-between; */
  /* background: #fff; */
}
.fr {
  float: right;
}
.mr {
  margin-right: 0.09rem;
}
.look_limit {
  /* flex: 1; */
  text-align: center;
  background: #fff;
  font-family: PingFangSC;
  font-weight: 400;
  padding-top: 0.24rem;
  padding-bottom: 0.15rem;
  width: 49%;
  display: inline-block;
  margin-bottom: 0.1rem;
  position: relative;
}
.name {
  font-size: 0.14rem;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 0.05rem;
}
.limit {
  font-size: 0.12rem;
  color: rgba(255, 81, 74, 1);
}
.moreMoney {
  color: rgba(153, 153, 153, 1);
  font-size: 0.1rem;
  margin-top: 0.05rem;
}

.coins {
  display: inline-block;
  width: 0.12rem;
  height: 0.12rem;
  background: url("../../assets/img/vip/luck/coins1.png") no-repeat center
    center;
  background-size: 100% 100%;
  position: relative;
  top: 0.01rem;
  margin-right: 0.03rem;
}
.isHot {
  position: absolute;
  right: 0;
  top: -0.02rem;
  display: inline-block;
  width: 0.26rem;
  height: 0.26rem;
  background: url("../../assets/img/vipActive/isHot.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.bank_icon,
.people_icon,
.safe_icon {
  display: inline-block;
  width: 0.96rem;
  height: 0.56rem;
  /* background: url("../../assets/img/vipActive/bank_auth.png") no-repeat center
    center;
  background-size: 100% 100%; */
}
.logo {
  width: 0.96rem;
  height: 0.56rem;
  /* margin-bottom: 0.15rem; */
}
</style>
